<template lang="html">
  <div>
    <div id="imageContainer">
      <draggable v-model="slideArray" class="row" :move="onMove" @update="onUpdate">
        <div
          v-for="(slide, idx) in slideArray"
          :key="'slide_' + idx"
          :class="{'activeImage': idx == slide_index}"
          :style="thumbStyle(idx)"
          class="imageGrid"
        >
          <img :src="path_to_assets + slide.file">
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: "Grid",
  components:{
    draggable
  },
  props:{
    onOrderChange:{
      type: Function,
      default: () => {
        return () => {}
      }
    },
    slide_array: {
      type: Array,
      default: () => []
    },
    path_to_assets:{
      type: String,
      default: () => ""
    },
    slide_index:{
      type: Number,
      default: () => 0
    }
  },
  data(){
    return {
      slideArray: [],
      thumbWidth: 100,
      thumbHeight: 100
    }
  },
  computed:{
    thumbStyleSelected(){
      return {
        width: this.thumbWidth + 'px',
        height: this.thumbHeight + 'px'
      }
    }
  },
  watch:{
    slide_array(value){
      this.slideArray = value;
    }
  },
  mounted(){
    this.slideArray = this.slide_array;
  },
  methods:{
    adjustThumbSize(multiplier){
      // Called externally.
      this.thumbWidth = this.thumbWidth * multiplier;
      this.thumbHeight = this.thumbWidth;
    },
    onMove(evt){
      console.log(evt);
    },
    onUpdate(evt){
      console.log(evt);
      //console.log("Index", evt.oldIndex)
      //console.log("Moving to ... ", evt.newIndex)
      this.$emit("onOrderChange", this.slideArray);
    },
    thumbStyle(idx){
      var style = {
        width: this.thumbWidth + 'px',
        height: this.thumbHeight + 'px'
      };
      // If idx is active, return with border.
      if(idx == this.slide_index){
        var border_width = 2;
        style = {
          width: (this.thumbWidth - (2 * border_width)) + 'px',
          height: (this.thumbHeight - (2 * border_width)) + 'px',
          'border-style': 'solid',
          'border-width': border_width + 'px',
        }
      }
      return style;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/Editor/_variables.scss";

#imageContainer{
  width: 100%;
  height: 100%;
  display: inline-block;
  .imageGrid{
    display: inline-block;
    float: left;
    overflow: hidden;
    margin: 4px;
    background-color: $grid-thumb-background;
    border-color: $grid-thumb-highlights;
    box-shadow: $grid-thumb-shadow;
    img{
      position: relative;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
